import * as z from 'zod';

export const AttachmentSchema = z.object({
  mimeType: z.string().nonempty(),
  name: z.string().nonempty(),
});
export type Attachment = z.infer<typeof AttachmentSchema>;
